import { Component, Injectable, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ClienteInterface } from 'app/module/cliente-interface';
import { ProdutoInterface } from 'app/module/produto-interface';
import { PedidoIsencaoInterface } from 'app/module/pedido-isencao-interface';
import { ClienteService } from '@core/services/cliente.service';
import { TipoItemService } from '@core/services/tipo-item.service';
import { PedidoIsencaoService } from '@core/services/pedido-isencao.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}
@Component({
	selector: 'app-pedido-isencao',
	templateUrl: './pedido-isencao.component.html',
	styleUrls: ['./pedido-isencao.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [
			{ provide: NgbDateAdapter, useClass: CustomAdapter },
			{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
		],
})
export class PedidoIsencaoComponent implements OnInit {
	public form: FormGroup;
	// public clientes: ClienteInterface[] = [];
	public produtos: ProdutoInterface[] = [];
	public loading: boolean = false;
	public termoPesquisa: string = '';
	public selectedCliente: any = null;
	public carregando: boolean = false;
	public clienteNaoEncontrado: boolean = false;
	contentHeader: object;
	private timer: any;
	public clientes;
	public modalProdutosConteudo: string = '';
	public itens: any[] = [];
	private modalRef: any = null;
	public paginacao: { pagina: number; itensPerPage: number; total: number } = { pagina: 1, itensPerPage: 5, total: 0 };
	public Math = Math;
	pedido = {
			id_pedido: null,
			id_cliente: null,
			id_produto: null,
			id_status: 1,
			dt_compra: null,
			dt_fim_isencao: null,
			dt_insert: null,
			itens: []
		}

	constructor(
		private fb: FormBuilder,
		private clienteService: ClienteService,
		private tipoItemService: TipoItemService,
		private pedidoIsencaoService: PedidoIsencaoService,
		private modalService: NgbModal,
		private router: Router,
		private route: ActivatedRoute
	) { }

	ngOnInit(): void {
		this.form = this.fb.group({
			id_pedido:  this.route.snapshot.params.id,
			id_cliente: [null, Validators.required],
			id_produto: [null, Validators.required],
			dt_compra: [null, Validators.required],
			dt_fim_isencao: [null, Validators.required],
			quantidade: [1, [Validators.required, Validators.min(1)]]
		});

		this.loadClientes();
		this.loadProdutos();

		this.contentHeader = {
			headerTitle: this.form.value.id_pedido ? "Gerenciar Isenção" : "Novo Pedido de Isenção",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Pedido",
						isLink: false,
					},
					{
						name: this.form.value.id_pedido ? "Gerenciar" : "Novo",
						isLink: false,
					},
				],
			},
		};
	}

	loadClientes() {
		this.clienteService.get().subscribe(
			(res) => {
				if (res) this.clientes = res;
			},
			(err) => console.error(err)
		);
	}


	onKeyUp(event) {
		if (!this.termoPesquisa || this.termoPesquisa.length < 3) {
			this.clientes = [];
			this.clienteNaoEncontrado = false;
			return;
		}

		this.carregando = true;
		this.clienteNaoEncontrado = false;
		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
            this.clientes = [];
            this.clienteService.pesquisa(this.termoPesquisa).subscribe((res) => {
                if (res[0].length > 0) {
                    let temp = res[0];
                    temp.forEach(element => {
                        let option = { 'id_cliente': element.id_cliente, 'id_sistema': 2, 'email_cliente': element.email_cliente, 'razao_social': element.razao_social, 'nome_fantasia': element.nome_fantasia, 'nome_contratante': element.nome_contratante, 'nome': element.nome_fantasia.toUpperCase() + ' | ' + element.cpf_cnpj_cliente };
                        this.clientes.push(option);
                    });
                    this.carregando = false;
                } else {
                    this.carregando = false;
                    this.clienteNaoEncontrado = true
                }
            },
                (error) => {
                    error
                    this.carregando = false;
                }
            );

        }, 2000);
	}

	setCliente(option) {
		this.selectedCliente = option;
		this.form.patchValue({ id_cliente: option.id_cliente });
		this.termoPesquisa = option.nome_contratante || option.razao_social || option.nome_fantasia || option.nome || '';
		this.clienteNaoEncontrado = false;
	}

	loadProdutos() {
		this.tipoItemService.getProduto().subscribe(
		(res) => {
			if (res && res.data) this.produtos = res.data;
		},
		(err) => console.error(err)
		);
	}

	modalProdutoOpen(modalBasic, item) {
        this.modalProdutosConteudo = '';
        this.modalRef = this.modalService.open(modalBasic, {
            windowClass: 'modal',
            size: 'xl',
            centered: true
        });
    }

	confirmarItens() {
		if (!this.modalProdutosConteudo || this.modalProdutosConteudo.trim() === '') {
			Swal.fire('Atenção', 'Digite pelo menos um item.', 'warning');
			return;
		}

		const linhas = this.modalProdutosConteudo.split('\n').map(linha => linha.trim()).filter(linha => linha !== '');

		if (linhas.length === 0) {
			Swal.fire('Atenção', 'Nenhum item válido encontrado.', 'warning');
			return;
		}

		this.itens = linhas.map(item => ({
			id_produto: this.form.value.id_produto,
			descricao: item,
			quantidade: 1
		}));

		this.paginacao.total = this.itens.length;
		this.paginacao.pagina = 1;

		Swal.fire('Sucesso', `${this.itens.length} item(ns) adicionado(s) ao pedido.`, 'success');
		this.cancelar();
	}

	removerItem(index: number) {
		this.itens.splice(index, 1);
		this.paginacao.total = this.itens.length;
		Swal.fire('Removido', 'Item removido com sucesso.', 'info');
	}

	removerTodos() {
		if (this.itens.length === 0) {
			Swal.fire('Atenção', 'Não há itens para remover.', 'warning');
			return;
		}

		Swal.fire({
			title: 'Confirmar',
			text: `Deseja remover todos os ${this.itens.length} item(ns)?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#161D31',
			cancelButtonColor: '#6e7d88',
			confirmButtonText: 'Sim, remover',
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				this.itens = [];
				this.paginacao.total = 0;
				this.paginacao.pagina = 1;
				Swal.fire('Removido', 'Todos os itens foram removidos.', 'success');
			}
		});
	}

	get itensPaginados() {
		const inicio = (this.paginacao.pagina - 1) * this.paginacao.itensPerPage;
		const fim = inicio + this.paginacao.itensPerPage;
		return this.itens.slice(inicio, fim);
	}

	mudarPagina(pagina: number) {
		this.paginacao.pagina = pagina;
	}

	cancelar() {
		if (this.modalRef) {
			try {
				this.modalRef.dismiss('Cancelado');
			} catch (e) {
				console.warn('Erro ao fechar modal:', e);
			}
		}
		this.modalProdutosConteudo = '';
	}

	voltarListagem() {
		this.router.navigate(['/pedido-isencao']);
	}

	submit() {
		// Validação completa
		if (this.form.invalid) {
			Swal.fire('Atenção', 'Preencha os campos obrigatórios (Cliente, Produto, Data de Compra, Data Fim Isenção).', 'warning');
			return;
		}

		if (!this.selectedCliente || !this.form.value.id_cliente) {
			Swal.fire('Atenção', 'Selecione um cliente válido.', 'warning');
			return;
		}

		if (!this.form.value.id_produto) {
			Swal.fire('Atenção', 'Selecione um produto.', 'warning');
			return;
		}

		if (this.itens.length === 0) {
			Swal.fire('Atenção', 'Adicione pelo menos um item ao pedido.', 'warning');
			return;
		}

		if (!this.form.value.dt_compra) {
			Swal.fire('Atenção', 'Informe a data de compra.', 'warning');
			return;
		}

		if (!this.form.value.dt_fim_isencao) {
			Swal.fire('Atenção', 'Informe a data fim da isenção.', 'warning');
			return;
		}

		// Construir o objeto pedido conforme especificado
		const pedido: PedidoIsencaoInterface = {
			id_pedido: null,
			id_cliente: this.form.value.id_cliente,
			id_produto: this.form.value.id_produto,
			id_status: 1,
			dt_compra: this.form.value.dt_compra,
			dt_fim_isencao: this.form.value.dt_fim_isencao,
			dt_insert: null,
			itens: this.itens.map(item => ({
				id_produto: item.id_produto,
				descricao: item.descricao,
				quantidade: item.quantidade
			}))
		};

		this.loading = true;
		this.pedidoIsencaoService.post(pedido).subscribe(
			(res) => {
				this.loading = false;
				Swal.fire('Sucesso', 'Pedido de isenção criado com sucesso.', 'success');
				this.router.navigate(['/pedido-isencao']);
			},
			(err) => {
				this.loading = false;
				console.error(err);
				Swal.fire('Erro', 'Falha ao criar pedido. Verifique o console.', 'error');
			}
		);
	}
}
